import { useCallback } from 'react';
import { graphql } from '@xolv-mybrightlink/common';
import { gql } from '@apollo/client';

export const useCommunityOptOut = () => {
  return useCallback(async () => {
    await graphql.mutate({
      mutation: gql`
        mutation withdrawFromCommunity {
          withdrawFromCommunity
        }
      `,
    });
  }, []);
};
